export default "__VITE_ASSET__eefa4dc6__"